/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'polaris-coreweb/exports';

const getHelmetForSpecList = (props) => {
  const {
    layoutData: {
      page: {
        url,
        title,
        vehicleSpecList: {
          trims: items,
        },
      },
    },
    metaData: {
      pageTitle: metaTitle,
    },
    config: {
      siteUrl,
    },
  } = props;

  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    url: `${siteUrl}${url}`,
    name: title || metaTitle,
    numberOfItems: 0,
    itemListElement: [],
  };

  items.forEach((brand) => {
    brand.items.forEach((model) => {
      let price = model.price.value.replace('£', '');
      price = price.replace(',', '.');

      const carItem = {
        '@type': 'Car',
        manufacturer: brand.name,
        name: `${brand.name} - ${model.name}`,
        description: `${brand.name} - ${model.name}, ${model.fuel.value}`,
        brand: brand.name,
        model: model.name,
        fuelType: model.fuel.value,
        fuelEfficiency: model.mpg.value,
        accelerationTime: model.acceleration.value,
        url: `${siteUrl}${model.path}`,
        speed: {
          '@type': 'QuantitativeValue',
          value: model.topSpeed.value,
        },
        offers: {
          '@type': 'Offer',
          availability: 'http://schema.org/InStock',
          price,
          priceCurrency: 'GBP',
          url: `${siteUrl}${model.path}`,
        },
      };

      const listItem = {
        '@type': 'ListItem',
        item: carItem,
      };

      jsonld.numberOfItems += 1;
      listItem.position = jsonld.numberOfItems;

      jsonld.itemListElement.push(listItem);
    });
  });

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
      <title>{title}</title>
    </Helmet>
  );
};

// @todo don't use PropTypes.array. Disable eslint for now.
/* eslint-disable react/forbid-prop-types */
getHelmetForSpecList.propTypes = {
  layoutData: PropTypes.shape({
    page: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      vehicleSpecList: PropTypes.array,
    }),
  }).isRequired,
  metaData: PropTypes.shape({
    pageTitle: PropTypes.string,
  }).isRequired,
  config: PropTypes.shape({
    siteUrl: PropTypes.string,
  }).isRequired,
};

export default getHelmetForSpecList;
